/** Lazy-loads the mobile Feedback screen. */

import { lazyLoad } from 'utils/loadable';

export const MobileFeedbackPage = lazyLoad(
  () => import('./MobileFeedbackPage'),
  module => module.MobileFeedbackPage
);
